import * as yup from 'yup';
import { CardData } from './ad-creation.types';
import { AD_CREATION_TEXTS } from './ad-creation.constants';

export const AD_CREATION_VALIDATION = { VALID: 'valid', INVALID: 'invalid' };

const inputSchema = yup.object().shape({
    headLinePart1: yup.string().required(AD_CREATION_TEXTS.FORM_ERROR),
    headLinePart2: yup.string().required(AD_CREATION_TEXTS.FORM_ERROR),
    headLinePart3: yup.string(),
    description1: yup.string().required(AD_CREATION_TEXTS.FORM_ERROR),
    description2: yup.string(),
    creativeFinalUrls: yup.string().url(AD_CREATION_TEXTS.FORM_ERROR)
        .required(AD_CREATION_TEXTS.FORM_ERROR),
});

export const adCreationCardValidation = (cardModalSelected: CardData) => {
    inputSchema
        .validateSync(cardModalSelected.custom_data.input);
};

const validateURLSchema = yup.string().url().required();
const verifyInputFieldSchema = yup.string().required();

const verifyInputFieldValue = (value: string): boolean => verifyInputFieldSchema.validate(value)
    .then(() => true)
    .catch(() => false);

const verifyUrlFieldValue = (url: string): boolean => validateURLSchema.validate(url)
    .then(() => true)
    .catch(() => false);

const isAdCreationFieldValid = (isValid: boolean): string => {
    if (isValid) return AD_CREATION_VALIDATION.VALID;
    return AD_CREATION_VALIDATION.INVALID;
};
export const verifyAdCreationFieldValue = async (value: string, field: string) => {
    switch (field) {
    case 'creativeFinalUrls':
        return isAdCreationFieldValid(await verifyUrlFieldValue(value));
    case 'headLinePart1':
    case 'headLinePart2':
    case 'description1':
        return isAdCreationFieldValid(await verifyInputFieldValue(value));
    default:
        return AD_CREATION_VALIDATION.VALID;
    }
};
